import React from 'react'

const EyeviewIcon = () => {
    return (
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.5613 6.92434C10.5613 8.34079 9.41672 9.4854 8.00026 9.4854C6.58381 9.4854 5.43921 8.34079 5.43921 6.92434C5.43921 5.50788 6.58381 4.36328 8.00026 4.36328C9.41672 4.36328 10.5613 5.50788 10.5613 6.92434Z" stroke="#111AE9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.9995 12.8396C10.5248 12.8396 12.8784 11.3516 14.5166 8.7762C15.1605 7.76751 15.1605 6.07205 14.5166 5.06337C12.8784 2.488 10.5248 1 7.9995 1C5.47423 1 3.12062 2.488 1.48239 5.06337C0.838551 6.07205 0.838551 7.76751 1.48239 8.7762C3.12062 11.3516 5.47423 12.8396 7.9995 12.8396Z" stroke="#222222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default EyeviewIcon